{
  "tabs": {
    "chat": "سۆزلەش",
    "reminders": "ئەسكەرتىشلەر",
    "calendar": "تەقۋىم",
    "settings": "تەڭشەكلەر"
  },
  "common": {
    "cancel": "بىكار قىلىش",
    "save": "ساقلاش",
    "confirm": "جەزملەش",
    "delete": "ئۆچۈرۈش",
    "back": "قايتىش",
    "close": "تاقاش",
    "edit": "تەھرىرلەش",
    "search": "ئىزدەش",
    "all": "ھەممىسى",
    "loading": "يۈكلەۋاتىدۇ...",
    "error": "خاتالىق كۆرۈلدى",
    "notFound": "تاپىلمايدۇ",
    "tryAgain": "قايتا سىناڭ",
    "retry": "قايتا سىناش",
    "undo": "ئەسلىگە كەلتۈرۈش",
    "pullToRefresh": "يېڭىلاش ئۈچۈن تارتىڭ",
    "justNow": "ھازىرلا"
  },
  "auth": {
    "welcome": "FishMemory غا خوش كەپسىز",
    "tagline": "سىزنىڭ WhatsApp ئەسكەرتىش ياردەمچىڭىز، ئەمدى جېبىڭىزدە.",
    "subtitle": "سىزنىڭ WhatsApp ئەسكەرتىش ياردەمچىڭىز، ئەمدى جېبىڭىزدە.",
    "phoneLabel": "سىزنىڭ WhatsApp نومۇرىڭىز",
    "phoneHint": "WhatsApp ئارقىلىق تەستىق كودى يوللايمىز",
    "invalidPhone": "توغرا نومۇر كىرگۈزۈڭ",
    "continue": "داۋاملاش",
    "enterPhone": "WhatsApp نومۇرىڭىزنى كىرگۈزۈڭ",
    "phonePlaceholder": "نومۇر",
    "sendCode": "كود يوللاش",
    "verifyTitle": "نومۇرىڭىزنى تەستىقلاڭ",
    "otpSentTo": "{{phone}} غا WhatsApp ئارقىلىق 6 سانلىق كود يوللاندى",
    "enterFullCode": "بارلىق 6 ساننى كىرگۈزۈڭ",
    "invalidOtp": "ناتوغرا كود. قايتا سىناڭ.",
    "otpFailed": "كود يوللاش مەغلۇپ بولدى. قايتا سىناڭ.",
    "otpResent": "كود قايتا يوللاندى",
    "resendIn": "{{seconds}} سېكۇنتتىن كېيىن قايتا يوللاش",
    "resendCode": "كودنى قايتا يوللاش",
    "enterOtp": "WhatsApp غا يوللانغان كودنى كىرگۈزۈڭ",
    "verify": "تەستىقلاش",
    "resend": "كودنى قايتا يوللاش",
    "wrongNumber": "نومۇر خاتا؟",
    "backToPhone": "نومۇرغا قايتىش",
    "editPhone": "نومۇرنى تەھرىرلەش",
    "error": "خاتالىق",
    "setupTitle": "تەڭشەشنى باشلايلى",
    "setupSubtitle": "بۇلارنى كېيىن تەڭشەكلەردە ئۆزگەرتەلەيسىز",
    "namePlaceholder": "ئىسمىڭىز",
    "letsGo": "تەڭشەشنى تاماملاش",
    "skipForNow": "ھازىرچە ئۆتكۈزۈپ يۈتكۈزۈش"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "خەۋەر يېزىڭ...",
    "inputPlaceholder": "خەۋەر يېزىڭ...",
    "typing": "FishMemory يېزىۋاتىدۇ...",
    "online": "توردا",
    "connecting": "ئۇلاشماقتا...",
    "reconnecting": "قايتا ئۇلاشماقتا...",
    "offline": "توردا ئەمەس",
    "empty": "سۆزلەشنى باشلاڭ",
    "emptyHint": "ئەسكەرتىش قۇرۇڭ، تەقۋىمىڭىزنى تەكشۈرۈڭ ياكى ياردەم سوراڭ.",
    "emptyAction": "مۇناسىۋەتلىك ئەسكەرتىش يوللاش",
    "actions": "سۆزلەش ھەرىكەتلىرى",
    "keep": "خەۋەرلەرنى ساقلاش",
    "clearTitle": "سۆزلەشنى تازىلاش",
    "clearConfirm": "بۇ ئۈسكۈنىدىن بارلىق خەۋەرلەر ئۆچۈرۈلسۇنمۇ؟ بۇنى قايتۇرۇپ بولمايدۇ.",
    "clear": "سۆزلەشنى تازىلاش",
    "optionSelected": "تاللانغان: {{label}}",
    "sendingSelection": "يوللانماقتا...",
    "connectionLost": "قايتا ئۇلاشماقتا..."
  },
  "reminders": {
    "title": "مېنىڭ ئەسكەرتىشلەر",
    "active": "ئىشلىتىلىۋاتقان",
    "today": "بۈگۈن",
    "thisWeek": "بۇ ھەپتە",
    "history": "تارىخ",
    "items": "بۇيۇم",
    "emptyTitle": "ھېچقانداق ئەسكەرتىش يوق",
    "emptySubtitle": "سۆزلەشتىن بىرنى قۇرۇڭ، بۇ يەردە كۆرۈنىدۇ.",
    "emptyAction": "سۆزلەشنى ئېچىش",
    "filterActive": "ئىشلىتىلىۋاتقان",
    "filterToday": "بۈگۈن",
    "filterWeek": "بۇ ھەپتە",
    "filterHistory": "تارىخ",
    "emptyState": "ئەسكەرتىش يوق. سۆزلەشنى باشلاڭ!",
    "swipeDone": "تامام",
    "swipeSnooze": "ۋاقىت ئۆتكۈزۈش",
    "swipeDelete": "ئۆچۈرۈش",
    "search": "ئەسكەرتىشلەردە ئىزدەش...",
    "upcoming": "يېقىنقى",
    "completed": "تاماملانغان",
    "overdue": "ۋاقتى ئۆتكەن",
    "tomorrow": "ئەتە",
    "synced": "{{value}} بىلەن ماسلاشتۇرۇلدى",
    "swipeHint": "كۆپ ھەرىكەت ئۈچۈن ئەسكەرتىشنى سۈرىڭ",
    "noResults": "ئىزدەش بىلەن ماس كەلگەن ئەسكەرتىش يوق",
    "noResultsHint": "باشقا كىلىمات سۆزىنى سىناڭ ياكى ئىزدەشنى تازىلاڭ",
    "deleteAllFailed": "بارلىق ئەسكەرتىشلەرنى ئۆچۈرۈش مەغلۇپ بولدى"
  },
  "calendar": {
    "title": "تەقۋىم",
    "today": "بۈگۈن",
    "tomorrow": "ئەتە",
    "completed": "تاماملانغان",
    "noEvents": "پىلانلانغان ئىش يوق",
    "noEventsSubtitle": "ئەسكەرتىشلەر ۋە تەقۋىم ۋەقەلەرنى كۆرۈش ئۈچۈن بىر كۈن تاللاڭ.",
    "googleEvent": "Google تەقۋىمى",
    "legendActive": "ئىشلىتىلىۋاتقان",
    "legendRecurring": "قايتىلانما",
    "legendDone": "تاماملانغان",
    "legendGoogle": "Google",
    "previousMonth": "ئالدىنقى ئاي",
    "nextMonth": "كېيىنكى ئاي",
    "previousYear": "ئالدىنقى يىل",
    "nextYear": "كېيىنكى يىل",
    "goToToday": "بۈگۈنكى كۈنگە بېرىش",
    "all": "ھەممىسى",
    "active": "ئىشلىتىلىۋاتقان",
    "done": "تاماملانغان",
    "paused": "ۋاقىتلىق توختىتىلغان"
  },
  "settings": {
    "title": "تەڭشەكلەر",
    "profile": "پروفىل",
    "name": "كۆرسىتىش ئىسمى",
    "enterName": "ئىسمىڭىزنى كىرگۈزۈڭ",
    "language": "تىل",
    "uiLanguage": "ئەپ تىلى",
    "uiLanguageHelp": "پەقەت بۇ ئۈسكۈنىدە ئەپ UI، تەقۋىم بەلگىلىرى ۋە يۆنىلىشىنى ئۆزگەرتىدۇ.",
    "serverLanguage": "سۆزلەش تىلى",
    "serverLanguageHelp": "سىزنىڭ ھېساباتىڭىز ئۈچۈن مۇلازىمېتچى جاۋابلىرى ۋە ئەسكەرتىش خەۋەرلىرى تىلىنى ئۆزگەرتىدۇ.",
    "timezone": "ۋاقىت رايونى",
    "currentTimezone": "نۆۋەتتىكى ۋاقىت رايونى",
    "timezoneHelp": "بارلىق ئەسكەرتىش ۋاقىتلىرى بۇ ۋاقىت رايونىدا كۆرۈنىدۇ.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ۋاقىت رايونىنى ساقلاش",
    "timezoneSaved": "ۋاقىت رايونى يېڭىلاندى",
    "detect": "بايقاش",
    "detectFailed": "ۋاقىت رايونىنى بايقاش مەغلۇپ بولدى",
    "autoDetect": "GPS ئارقىلىق ئاپتوماتىك بايقاش",
    "notifications": "خەۋەرنامىلەر",
    "notificationsHelp": "ئەسكەرتىش يوللانغاندىن كېيىن قايتا ئاگاھلاندۇرۇشنى باشقۇرۇش. ئۈسكۈنى دەرىجىسىدىكى خەۋەرنامە ھوقۇقى تېلېفون تەڭشەكلەردە باشقۇرۇلىدۇ.",
    "pushEnabled": "پۇش خەۋەرنامىسى",
    "autoDoneOnFire": "ئاپتوماتىك تامام دەپ بەلگىلەش",
    "autoDoneOnFireDesc": "ئۆچۈرۈلگەن بولسا، ئەسكەرتىشلەر تاماملانمىغانچە قالىدۇ.",
    "googleCalendar": "Google تەقۋىمى",
    "google": "Google تەقۋىمى",
    "googleConnected": "ئۇلاشقان",
    "googleDisconnected": "ئۇلاشمىغان",
    "googleConnectedHelp": "يېڭى ئەسكەرتىشلەرنى تەقۋىمىڭىزغا ئاپتوماتىك ماسلاشتۇرالايسىز.",
    "googleDisconnectedHelp": "ئەسكەرتىشلەر ۋە ۋەقەلەرنى ماسلاشتۇرۇش ئۈچۈن Google تەقۋىمىغا ئۇلىنىڭ.",
    "googleConnectFailed": "Google تەقۋىمىغا ئۇلاش مەغلۇپ بولدى",
    "connected": "ئۇلاشقان",
    "disconnected": "ئۇلاشمىغان",
    "connect": "ئۇلاش",
    "disconnect": "ئۇلاشنى توختىتىش",
    "autoSync": "يېڭى ئەسكەرتىشلەرنى ئاپتوماتىك ماسلاشتۇرۇش",
    "autosync": "يېڭى ئەسكەرتىشلەرنى ئاپتوماتىك ماسلاشتۇرۇش",
    "subscription": "ئەزا بولۇش",
    "trialUsed": "سىناش: {{used}}/{{total}} ئىشلىتىلدى",
    "trialStatus": "سىناش مۇمكىن",
    "activeStatus": "ئەزا بولۇش ئاكتىپ",
    "expiredStatus": "ئەزا بولۇش مۇددىتى تۈگەش",
    "unsubscribedStatus": "ئەزا بولمىغان",
    "about": "ھەققىدە",
    "version": "نەشىر",
    "logout": "چىقىش",
    "logoutTitle": "چىقىش",
    "logoutConfirm": "چىقىشقا ئىشەنچىڭىز كاممۇ؟",
    "noName": "ئىسمى بەلگىلەنمىگەن",
    "serverConnection": "مۇلازىمېتچى ئۇلىنىشى",
    "serverUrl": "مۇلازىمېتچى URL",
    "serverEdit": "تەھرىرلەش",
    "saveReconnect": "ساقلاپ قايتا ئۇلاش",
    "resetDefault": "ئەسلىگە قايتۇرۇش",
    "invalidServerUrlTitle": "ناتوغرا مۇلازىمېتچى URL",
    "invalidServerUrlMessage": "توغرا http ياكى https مۇلازىمېتچى URL كىرگۈزۈڭ، مەسىلەن https://example.com",
    "uiLanguageChangeFailed": "ئەپ تىلىنى ئۆزگەرتەلمىدى. قايتا سىناڭ.",
    "serverLanguageChangeFailed": "سۆزلەش تىلىنى ئۆزگەرتەلمىدى. قايتا سىناڭ.",
    "timezoneChangeFailed": "ۋاقىت رايونىنى ئۆزگەرتەلمىدى. قايتا سىناڭ.",
    "autoSyncChangeFailed": "ئاپتوماتىك ماسلاشتۇرۇشنى يېڭىلاشتا مەغلۇپ بولدى. قايتا سىناڭ.",
    "nameChangeFailed": "كۆرسىتىش ئىسمىنى يېڭىلاشتا مەغلۇپ بولدى. قايتا سىناڭ.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ئەسكەرتىش تەپسىلاتى",
    "editTime": "ۋاقىتنى تەھرىرلەش",
    "rename": "ئاتىنى ئۆزگەرتىش",
    "snooze": "ۋاقىت ئۆتكۈزۈش",
    "snooze15": "15 مىنۇت ئۆتكۈزۈش",
    "pause": "توختىتىش",
    "pauseReminder": "ئەسكەرتىشنى توختىتىش",
    "resume": "قايتا باشلاش",
    "resumeReminder": "ئەسكەرتىشنى قايتا باشلاش",
    "skip": "كېيىنكىنى ئۆتكۈزۈش",
    "skipOccurrence": "بۇ قېتىملىقنى ئۆتكۈزۈش",
    "syncGoogle": "Google غا ماسلاشتۇرۇش",
    "delete": "ئۆچۈرۈش",
    "deleteTitle": "ئەسكەرتىشنى ئۆچۈرۈش",
    "deleteConfirm": "بۇ ئەسكەرتىش مەڭگۈ ئۆچۈرۈلىدۇ.",
    "deleteRecurringTitle": "قايتىلانما ئەسكەرتىشنى ئۆچۈرۈش",
    "deleteRecurringMessage": "بۇ قېتىملىقنى ئۆتكۈزەمسىز ياكى پۈتۈن قىسىمنى ئۆچۈرەمسىز؟",
    "deleteThisOccurrence": "بۇ قېتىملىقنى ئۆتكۈزۈش",
    "deleteEntireSeries": "پۈتۈن قىسىمنى ئۆچۈرۈش",
    "done": "تامام",
    "markDone": "تامام دەپ بەلگىلەش",
    "undo": "ئەسلىگە كەلتۈرۈش",
    "undoPrompt": "يەنە ئىشلىتىشنى خالامسىز؟ ھازىر ئەسلىگە كەلتۈرۈڭ.",
    "recurring": "قايتىلانما",
    "nextRun": "كېيىنكى ئىجرا",
    "oneTime": "بىر قېتىملىق",
    "pending": "كۇتۈۋاتىدۇ",
    "sent": "يوللاندى",
    "paused": "توختىتىلغان",
    "active": "ئىشلىتىلىۋاتقان",
    "snoozed": "ۋاقىت ئۆتكۈزۈلدى",
    "localTime": "يەرلىك ۋاقىتتا كۆرۈنىدۇ",
    "recurrence": "قايتىلانما",
    "created": "قۇرۇلدى",
    "tags": "بەلگىلەر",
    "fireCount": "ئىجرا سانى",
    "actions": "ھەرىكەتلەر",
    "none": "يوق",
    "snoozeFailed": "ئەسكەرتىشنى ئۆتكۈزۈش مەغلۇپ بولدى",
    "pauseFailed": "ئەسكەرتىشنى توختىتىش مەغلۇپ بولدى",
    "resumeFailed": "ئەسكەرتىشنى قايتا باشلاش مەغلۇپ بولدى",
    "skipFailed": "ئەسكەرتىشنى ئۆتكۈزۈش مەغلۇپ بولدى",
    "doneFailed": "ئەسكەرتىشنى تامام دەپ بەلگىلەش مەغلۇپ بولدى",
    "undoFailed": "ئەسكەرتىش ھالىتىنى ئەسلىگە كەلتۈرۈش مەغلۇپ بولدى",
    "deleteFailed": "ئەسكەرتىشنى ئۆچۈرۈش مەغلۇپ بولدى",
    "rescheduleTitle": "قايتا جەدۋەلگە كىرگۈزەمسىز؟",
    "rescheduleMsg": "بۇ ئەسكەرتىشنىڭ ۋاقتى ئۆتكەن. قايتا جەدۋەلگە كىرگۈزەمسىز؟",
    "reschedule15": "15 مىنۇتتىن كېيىن",
    "reschedule60": "1 سائەتتىن كېيىن",
    "keepOverdue": "ئاسلىدەك ساقلاش"
  },
  "onboarding": {
    "slide1Title": "FishMemory غا خوش كەپسىز",
    "slide1Sub": "شەخسىي ئەسكەرتىش ياردەمچىڭىز — WhatsApp ئارقىلىق ۋە جېبىڭىز ئۈچۈن قۇرۇلغان.",
    "slide2Title": "تەبىئىي سۆزلەڭ",
    "slide2Sub": "ئەسكەرتىشلەرنى ئويلىغانچە يېزىڭ: «ئەتە سائەت 3 دە ئانامغا تېلېفون قىلىشنى ئەسكەرت» — قالغانىنى بىز قىلىمىز.",
    "slide3Title": "ھېچقانداق نەرسىنى ئۆتكۈزۈپ قويماڭ",
    "slide3Sub": "ۋاقىتلىق خەۋەرنامىلەرنى ئېلىڭ، بەلگىلەر بىلەن تەرتىپلەڭ، ۋە مۇھىم ئىشلارغا دىققەت قىلىڭ.",
    "getStarted": "باشلاش",
    "next": "كېيىنكى",
    "firstReminderTitle": "بىرىنچى ئەسكەرتىشىڭىزنى قۇرۇڭ!",
    "firstReminderHint": "مەسىلەن تۆۋەندىكىدەك يېزىڭ:",
    "firstReminderExample": "ئەتە سائەت 9 دا سۇ ئىچىشنى ئەسكەرت",
    "gotIt": "چۈشەندىم!",
    "notifRationaleTitle": "ۋاقتىدا بولۇڭ",
    "notifRationaleBody": "FishMemory سىزگە ۋاقىتدا ئەسكەرتىش ئۈچۈن خەۋەرنامىلەرگە ئېھتىياجلىق. پەقەت ئۆزىڭىز قۇرغان ئەسكەرتىشلەر ئۈچۈن ئاگاھلاندۇرۇش ئالاسىز.",
    "notifRationaleAllow": "خەۋەرنامىلەرنى قوزغات",
    "notifRationaleLater": "كېيىنچە بولىدۇ",
    "swipeHint": "تىز ھەرىكەتلەر ئۈچۈن ئوڭغا سۈرىڭ →",
    "calendarDragHint": "كىڭەيتىش ئۈچۈن تارتىڭ ↕"
  }
}
